/* Good Travel · Antes de enviar el presupuesto.
   El formulario se envía de la forma normal de Shopify (así funciona su
   verificación antirobots). Aquí solo se completa el presupuesto orientativo
   cuando el cliente no ha movido la barra. */
(function () {
'use strict';
var root = document.getElementById('gtq');
if (!root) return;
var form = root.querySelector('form');
if (!form) return;
function fill(e) {
if (e.defaultPrevented) return;
var b = form.querySelector('[data-f="budget"]');
if (b && !b.value) b.value = 'Sin indicar (no movió la barra)';
}
var btn = form.querySelector('[data-submit]');
if (btn) btn.addEventListener('click', fill);
form.addEventListener('submit', fill);
})();
